<div class="relative flex items-center">
  <button
    type="button"
    class="inline-flex items-center gap-2 rounded-lg border bg-white p-2.5 text-sm font-medium text-body hover:bg-gray-100"
    [class]="pillBorderClass()"
    [attr.aria-expanded]="variant() === 'menu' ? menuOpen() : null"
    (click)="onPillClick()">
    @if (variant() === 'link' && timerLabel(); as timer) {
      <span class="font-semibold" [class]="timerTextClass()">{{ timer }}</span>
    }
    <span class="relative flex h-2 w-2" aria-hidden="true">
      <span
        class="absolute inline-flex h-full w-full animate-ping rounded-full bg-red-500 opacity-75"></span>
      <span class="relative inline-flex h-2 w-2 rounded-full bg-red-600"></span>
    </span>
    <span
      class="rounded-md bg-primary-600 px-1.5 py-1 text-xs leading-[150%] font-semibold uppercase tracking-wide text-white">
      Live
    </span>
    @if (patientName(); as name) {
      <span class="max-w-[12rem] truncate">{{ name }}</span>
    }
    @if (unreadCount() > 0) {
      <span
        class="rounded-full bg-primary-600 px-1.5 text-xs leading-5 text-white">
        {{ unreadCount() }}
      </span>
    }
    @if (variant() === 'menu') {
      <mat-icon
        class="!h-4 !w-4 text-gray-400"
        svgIcon="chevron-down"></mat-icon>
    }
  </button>

  @if (variant() === 'menu' && menuOpen()) {
    <div
      class="absolute right-0 top-full mt-2 w-48 overflow-hidden rounded-lg bg-white py-1 text-sm text-gray-800 shadow-xl ring-1 ring-black/10">
      <button
        type="button"
        class="block w-full px-4 py-2 text-left hover:bg-gray-100"
        [class.font-semibold]="mode() === 'side'"
        (click)="select('side')">
        Show side panel
      </button>
      <button
        type="button"
        class="block w-full px-4 py-2 text-left hover:bg-gray-100"
        [class.font-semibold]="mode() === 'mini'"
        (click)="select('mini')">
        Show mini panel
      </button>
      <button
        type="button"
        class="block w-full px-4 py-2 text-left hover:bg-gray-100"
        [class.font-semibold]="mode() === 'hidden'"
        (click)="select('hidden')">
        Hide
      </button>
      <div class="my-1 border-t border-gray-100"></div>
      <button
        type="button"
        class="block w-full px-4 py-2 text-left hover:bg-gray-100"
        (click)="onGoToPatient()">
        Go to patient's page
      </button>
    </div>
  }
</div>
